import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { SAMPLE_IDS, SAMPLE_THEMES } from "./themes";
export function SampleSwitcher({ active }) {
    return (_jsxs("div", { className: "fixed right-3 top-1/2 z-[70] -translate-y-1/2 hidden md:flex flex-col gap-1 rounded-2xl border border-black/10 bg-white/90 p-1 shadow-lg backdrop-blur-xl", children: [_jsx(Link, { to: "/samples", className: "px-2 py-1 text-[10px] uppercase tracking-widest text-black/40", children: "All" }), SAMPLE_IDS.map((id) => {
                const theme = SAMPLE_THEMES[id];
                const on = id === active;
                return (_jsx(Link, { to: `/samples/${id}`, className: "flex h-10 w-10 items-center justify-center rounded-xl text-[13px] font-semibold", style: {
                        background: on ? theme.cta : "transparent",
                        color: on ? theme.ctaText : theme.ink,
                    }, "aria-current": on ? "page" : undefined, title: theme.name, children: theme.number }, id));
            })] }));
}
export function SampleMobileBar({ active }) {
    return (_jsxs("div", { className: "sticky top-0 z-[70] flex md:hidden items-center gap-2 overflow-x-auto border-b border-black/10 bg-white/90 px-3 py-2 backdrop-blur", children: [_jsx(Link, { to: "/samples", className: "shrink-0 text-[11px] uppercase tracking-widest text-black/45", children: "All" }), SAMPLE_IDS.map((id) => {
                const theme = SAMPLE_THEMES[id];
                const on = id === active;
                return (_jsxs(Link, { to: `/samples/${id}`, className: "shrink-0 rounded-full px-3 py-1.5 text-[12px] font-medium", style: {
                        background: on ? theme.cta : "transparent",
                        color: on ? theme.ctaText : "#111",
                    }, children: [theme.number, " ", theme.name] }, id));
            })] }));
}
